<template>
  <!-- 在线月度分析报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <el-button class="export" type="primary" size="small" @click="toImage" v-if="false">生成PDF</el-button>
    <div style="margin-top:40px;" class="analysisReport_box" id="pdfPrint">

      <div class="header_titles">
        <h1>职业教育“{{header.zykName}}”专业教学资源库({{header.zykNum}})</h1>
        <h1 style="margin-top: 3px;">建设与应用分析简报</h1>
        <div class="number_time">
          <div>
            <span>{{yearMonthText}}</span>
            <span>数据分析时间：{{header.startTime}} 至 {{header.endTime}} </span>
          </div>
          <hr>
          <hr>
        </div>
      </div>

      <div class="division">
        <span>建设与更新情况</span>
      </div>

      <div class="chart_box">
        <h4>一、用户建设与更新情况</h4>
        <h4 style="margin-left: 40px;">1.1 用户总览</h4>
        <p>当前该资源库的用户数(教师和学生)为{{ziyuan.total}}人，
          其中学生{{ziyuan.student}}人，占{{ziyuan.studentList}}%；
          教师{{ziyuan.teacher}}人，
          占{{ziyuan.teacherList}}%(如图1 所示)。这些用户来自全国{{ziyuan.totalProvince}}个省级行政区，{{ziyuan.totalSchool}}所学校。
          {{resourceLibrary.FristYear}}{{resourceLibrary.FristNum}}人，
          {{resourceLibrary.SecondYear}}{{resourceLibrary.SecondNum}}人，
          {{resourceLibrary.ThirdYear}}{{resourceLibrary.ThirdNum}}人，
          {{resourceLibrary.FourthYear}}{{resourceLibrary.FourthNum}}人。
          共删除用户{{resourceLibrary.delNum}}人。
        <div class="standards_content echartsHeight">
          <circularChart :refId="'resourceLibraryChart'" :datas='ziyuan.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图1 资源库注册用户类型分布总体情况</div>
        <!-- <div class="standards_content echartsHeight">
          <distributionChart style="margin-top: 30px;" :refId="'studentUsersOverYearsChart'" :color="shengfenperson.colorList" :datas="shengfenperson.dataList" :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></distributionChart>
        </div> -->
        <!-- <div class="chart_name">图2 各省份注册用户数量（单位：人）</div> -->
      </div>
      <div class="boxss" style="height: 140px;">

      </div>
      <!-- 资源库用户注册时间分布 -->
      <div class="chart_box" style="margin-top: 40px;">
        <h4 style="margin-left: 40px;">1.2 资源库用户注册时间分布</h4>
        <!-- 柱图 -->
        <div class="standards_content echartsHeight">
          <vcolumnarChart style="margin-left: -140px;" id="map" :refId="'participatingChart'" :datas='register.dataList' :legendList="register.legendList" :colorList="register.colorList" :transverseData="register.transverseData" :colorName='1' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></vcolumnarChart>
        </div>
        <div class="boxss" style="height: 180px;">

        </div>
        <!-- 折线图 -->
        <div class="standards_content echartsHeight">
          <discountChart style="margin-left: -140px;" :refId="'typeDistributionChart'" :datas='UserCreateList.dataList' :legendList="UserCreateList.legendList" :transverseData='UserCreateList.transverseData' :colorList='UserCreateList.colorList' :colorName='2' :innerText="'单位:人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name">图2 资源库用户注册时间分布情况（分别按年、月统计）</div>
      </div>

      <div class="chart_box">
        <h4 style="margin-left: 40px;">1.3 参建单位注册用户排名</h4>
        <p>当前,该资源库参建单位注册用户(教师和学生)情况排名如图3所示。</p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart style="margin-left: -140px;" :refId="'typeDistributionChart'" :datas='projectTop.dataList' :transverseData="projectTop.transverseData" :colorList='projectTop.colorList' :colorName='2' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
        </div>
        <div class="chart_name">图3 当前资源库参建单位注册用户（教师和学生）情况排名（前十名）</div>
      </div>

      <div class="chart_box">
        <h4>二、素材资源建设与更新情况</h4>
        <h4 style="margin-left: 40px;">2.1 素材资源总览</h4>
        <p>该资源库的总数为{{sucaiziyuanAll.total}}条，其中文本类和图形/图像类为{{sucaiziyuanAll.textVo.sumValue}}条，文本型演示稿类(包含PPT、
          网页课件、富媒体等)为{{sucaiziyuanAll.textPPTVo.sumValue}}条，文本类、图形图像类和文本型演示稿类数量占比为{{sucaiziyuanAll.textPPTVo.percentage}}(如图4所示)。
          {{sucaiyearAdd.SecondYear}}{{sucaiyearAdd.SecondNum}}条，
          {{sucaiyearAdd.ThirdYear}}{{sucaiyearAdd.ThirdNum}}条，
          {{sucaiyearAdd.FourthYear}}{{sucaiyearAdd.FourthNum}}条，
          {{sucaiyearAdd.FifthYear}}{{sucaiyearAdd.FifthNum}}条，共删除{{sucaiyearAdd.delNum}}条。</p>
        <div class="standards_content echartsHeight">
          <circularChart style="margin-left: -180px;" :refId="'typeDistributionChart'" :datas='sucaiziyuanAll.dataList' :colorName='2' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图4 资源库素材资源类型分布</div>
      </div>
      <div class="boxss" style="height: 50px;">

      </div>
      <div class="chart_box">
        <h4 style="margin-left: 40px;">2.2 素材资源创建时间分布</h4>
        <div class="standards_content echartsHeight">
          <vcolumnarChart style="margin-left: -140px;" :refId="'participatingChart'" :datas='sucaiziyuanCreated.dataList' :transverseData="sucaiziyuanCreated.transverseData" :colorList="sucaiziyuanCreated.colorList" :legendList="sucaiziyuanCreated.legendList" :colorName='2' :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></vcolumnarChart>
        </div>
        <div class="standards_content echartsHeight">
          <discountChart style="margin-left: -140px;" :refId="'participatingChart'" :datas='SucaiziyuanCreated.dataList' :transverseData="SucaiziyuanCreated.transverseData" :colorList="SucaiziyuanCreated.colorList" :legendList="SucaiziyuanCreated.legendList" :colorName='2' :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name">图5 素材资源创建时间分布（分别按年、月统计）</div>
      </div>

      <div class="chart_box">
        <h4>三、课程建设与更新情况</h4>
        <h4 style="margin-left: 40px;">3.1 课程总览</h4>
        <p>该资源库建有标准化课程{{kechengAll.count}}门。<br> （注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性是由资源库建设团队保证。注2：如标准化课程显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）</p>
        <div class="chart_name"></div>
      </div>

      <div class="chart_box">
        <h4 style="margin-left: 40px;">3.2 课程创建时间分布</h4>
        <!-- 人数饼状图 -->
        <div class="standards_content echartsHeight">
          <vcolumnarChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='kechengcreateds.dataList' :transverseData="kechengcreateds.transverseData" :colorList='projectTop.colorList' :colorName='1' :innerText="'单位:门'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></vcolumnarChart>
        </div>
        <div class="chart_name" style="margin-top:-50px;">图6 课程创建时间分布</div>
      </div>

      <!-- 应用情况 -->
      <hr>
      <div class="division" style="padding-top: 40px;">
        <span>应用情况</span>
      </div>

      <div class="chart_box">
        <h4>四、用户行为情况</h4>
        <h4 style="margin-left: 40px;">4.1 用户行为类型分布</h4>
        <p>该资源库用户行为活动总量为{{useractiveAllList.total}}次，参与用户数{{userTotal.actionUser}}人，素材资源使用总次数{{useractiveAllList.sucai}}次，平均每个资源使用次数为{{useractiveAllList.sucaiAvg}}次。
          论坛活动模块{{useractiveAllList.luntan}}次，作业活动模块{{useractiveAllList.zuoye}}次，考试活动模块{{useractiveAllList.kaoshi}}次，(如图7所示)。该资源库2021年用户行为总量为{{userTotal.total}}次，学生人均行为次数为{{userTotal.studentAvg}}次。
        </p>
        <div class="standards_content echartsHeight">
          <circularChart style="margin-left: -140px;" :refId="'typeDistributionChart'" :datas='useractiveAllList.dataList' :colorName='2' :innerText="'单位:次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图7 资源库用户行为类型分布情况</div>

        <div class="standards_content echartsHeight">
          <discountChart style="margin-left: -180px;" :refId="'typeDistributionChart'" :datas='sss.dataList' :colorList="sss.colorList" :innerHtml="'单位:次'" :transverseData="sss.transverseData" :colorName='2' :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name">图8 近一年用户行为产生的时间分布情况（按天统计）</div>
      </div>

      <div class="chart_box">
        <h4 style="margin-left: 40px;">4.2 近一年不同类型用户行为分布</h4>
        <div class="standards_content echartsHeight">
          <circularChart style="margin-left: -180px;" :refId="'typeDistributionChart'" :datas='userxingwei.dataList' :colorList="userxingwei.colorList" :colorName='2' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
        </div>
        <div class="chart_name">图9 不同类型用户产生的行为分布情况</div>
      </div>

      <div class="chart_box" style="padding-top:40px;">
        <h4 style="margin-left: 40px;">4.3 近一年不同类型用户行为时间分布情况</h4>
        <div class="standards_content echartsHeight">
          <discountChart style="margin-left: -140px;" :refId="'typeDistributionChart'" :legendList="differentUserTime.legendList" :datas='differentUserTime.dataList' :transverseData="differentUserTime.transverseData" :colorList='differentUserTime.colorList' :colorName='2' :innerText="'单位:次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name">图10 近一年不同类型用户行为时间分布情况</div>
      </div>

      <div class="chart_box" style="padding-top:40px">
        <h4 style=" margin-left: 40px;">4.4 教师访问情况排名</h4>
        <div class="standards_content echartsHeight">
          <tcolumnarChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='tearchTopList.dataList' :colorList="tearchTopList.colorList" :transverseData="tearchTopList.transverseData" :colorName='1' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
        </div>
        <div class="chart_name">图11 教师访问量排名（前十名）</div>
      </div>

      <div class="chart_box">
        <h4 style="margin-left: 40px;">4.5 学生访问情况排名</h4>
        <div class="standards_content echartsHeight">
          <tcolumnarChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='studentTopList.dataList' :colorList="studentTopList.colorList" :transverseData="studentTopList.transverseData" :colorName='1' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
        </div>
        <div class="chart_name">图12 学生访问量排名（前十名）</div>
      </div>

      <div class="chart_box" style="padding-top: 40px;">
        <h4>五、素材资源应用情况</h4>
        <h4 style="margin-left: 40px;">5.1 近一年素材资源访问情况</h4>
        <div class="standards_content echartsHeight">
          <discountChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='sucaiziyuanyingyong.dataList' :transverseData="sucaiziyuanyingyong.transverseData" :legendList="sucaiziyuanyingyong.legendList" :colorList='sucaiziyuanyingyong.colorList' :colorName='1' :innerText="'单位:次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name">图13 近一年素材资源访问情况</div>
      </div>

      <div class="chart_box">
        <h4 style="margin-left: 40px;">5.2 素材资源访问量排名</h4>
        <!-- 人数饼状图 -->
        <div class="standards_content echartsHeight">
          <tcolumnarChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='sucaiziyuanfagnwen.dataList' :transverseData="sucaiziyuanfagnwen.transverseData" :colorList='sucaiziyuanfagnwen.colorList' :colorName='1' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
        </div>
        <div class="chart_name">图14 素材资源访问量排名（前十名）</div>
      </div>

      <div class="chart_box">
        <h4>六、课程应用情况</h4>
        <h4 style="margin-left: 40px;">6.1 近一年课程访问情况</h4>
        <div class="standards_content echartsHeight">
          <discountChart style="margin-left: -180px;" :refId="'resourceLibraryChart'" :datas='oneYearkecheng.dataList' :transverseData="oneYearkecheng.transverseData" :colorList='oneYearkecheng.colorList' :legendList='oneYearkecheng.legendList' :colorName='1' :innerText="'单位:次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></discountChart>
        </div>
        <div class="chart_name" style="margin-bottom: 80px;">图15 近一年课程访问情况</div>
      </div>
      <div class="000" style="height: 80px;"></div>
      <div class="chart_box">
        <h4 style="margin-left: 40px;">6.2 课程访问量排名</h4>
        <div class="standards_content echartsHeight">
          <tcolumnarChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='oneYearkechengfagnwen.dataList' :transverseData="oneYearkechengfagnwen.transverseData" :colorList='oneYearkechengfagnwen.colorList' :colorName='1' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
        </div>
        <div class="chart_name">图16 课程访问量排名（前十名）</div>
      </div>
      <div style="height: 80px;"></div>

      <div class="chart_box">
        <h4 style="margin-left: 40px;">6.3 课程活跃用户量排名</h4>
        <div class="standards_content echartsHeight">
          <tcolumnarChart style="margin-left: -140px;" :refId="'resourceLibraryChart'" :datas='kechengActiveTop.dataList' :colorList="kechengActiveTop.colorList" :transverseData="kechengActiveTop.transverseData" :colorName='1' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
        </div>
        <div class="chart_name">图17 课程活跃用户量排名（前十名）</div>
      </div>

      <el-backtop></el-backtop>
    </div>
  </div>
</template>

<script>
import circularChart from '@/components/chart/circularChart.vue'; // 引入圆形图表
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue'; // 引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'; // 引入横柱图图表
import discountChart from '@/components/chart/discountChart.vue'; // 引入折线图图表
import waterDropChart from '@/components/chart/waterDropChart.vue'; // 引入水滴图图表
import distributionChart from '@/components/chart/distributionChart.vue';
// 地图 
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart
  },
  data() {
    return {
      year: '',
      yearAndMonthly: '',
      yearMonthText: '',
      zykStatus: '已立项',
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'], // 柱状图或折线图的颜色
      colorList1: ['#ff70a3', '#ededed', '#d88bff', '#95ec69', '#8f8f8f', '#cdcdcd', '#AD8E4B', '#CA524B'],

      header: {
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: ''
      },

      resourceLibrary: { // 图1 资源库注册用户类型分布总体情况
        dataList: [],
        total: 0,
        FristYear: '',
        SecondYear: '',
        ThirdYear: '',
        FourthYear: '',
        // FifthYear: '',
        FristNum: 0,
        SecondNum: 0,
        ThirdNum: 0,
        FourthNum: 0,
        // FifthNum: 0,
        // teacherNum: 0,
        // studenNum: 0,
        delNum: 0
      },
      shengfenperson: {
        dataList: [],
        colorList: [],
      },
      register: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      ziyuan: {
        dataList: [],
        other: 0,
        total: 0,
        teacher: 0,
        totalProvince: 0,
        student: 0,
        studentList: 0,
        teacherList: 0,
        social: 0,
        enterprise: 0,
        totalSchool: 0
      },
      ziyuantu: {
        dataList: [],
        transverseData: [],
        colorList: []
      },
      UserCreateList: {  // 图2 新用户注册情况分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },

      projectTop: {  // 图三 参加单位注册用户数排名
        dataList: [],
        colorList: [],
        transverseData: []
      },

      sucaiziyuanAll: {
        total: 0,
        dataList: [],
        textVo: {
          sumValue: 0,
          percentage: 0
        },
        textPPTVo: {
          sumValue: 0,
          percentage: 0
        },
        animationVo: {
          sumValue: 0,
          percentage: 0
        },
        virtualVo: {
          sumValue: 0,
          percentage: 0
        },
        audioVo: {
          sumValue: 0,
          percentage: 0
        },
        videoVo: {
          sumValue: 0,
          percentage: 0
        },
        smallCourseVo: {
          sumValue: 0,
          percentage: 0
        },
        otherVo: {
          sumValue: 0,
          percentage: 0
        },
        originVo: {
          sumValue: 19016,
          percentage: 0
        },
        noActiveResourceCountVo: {
          sumValue: 177,
          percentage: 0
        },
        courseResourceVo: {
          sumValue: 0,
          percentage: 0
        },
        questionVo: {
          sumValue: 0,
          percentage: 0
        },
        resourceLogCount: 0,
        viewResourceVo: {
          sumValue: 0,
          percentage: 0
        },
        commentResourceVo: {
          sumValue: 0,
          percentage: 0
        },
        downloadResourceVo: {
          sumValue: 0,
          percentage: 0
        },
        collectionResourceVo: {
          sumValue: 0,
          percentage: 0
        },
        otherResourceVo: {
          sumValue: 0,
          percentage: 0
        },
        averageResourceLogCount: 46
      },
      sucaiyearAdd: {
        FristYear: '',
        SecondYear: '',
        ThirdYear: '',
        FourthYear: '',
        FifthYear: '',
        FristNum: 0,
        SecondNum: 0,
        ThirdNum: 0,
        FourthNum: 0,
        FifthNum: 0,
        delNum: 0
      },
      sucaiziyuanCreated: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      SucaiziyuanCreated: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      kechengAll: {
        count: 0
      },
      kechengcreateds: {
        dataList: [],
        colorList: [],
        transverseData: []
      },
      useractiveAllList: {
        total: 0,
        dataList: [],
        colorList: [],
        transverseData: [],
        ziyuansucai: 0,
        luntan: 0,
        zuoye: 0,
        kaoshi: 0,
        sucaiAvg: 0
      },
      userTotal: {
        total: 0,
        studentAvg: 0,
        actionUser: 0
      },
      differentUserTime: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: []
      },
      userxingwei: {
        dataList: [],
        colorList: []
      },
      sucaiziyuanyingyong: {
        dataList: [],
        colorList: [],
        transverseData: [],
        legendList: []
      },
      sucaiziyuanfagnwen: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      oneYearkecheng: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      oneYearkechengfagnwen: {
        dataList: [],
        colorList: [],
        transverseData: [],
      },
      typeDistribution: { // 图2  当前资源库资源、课程情况
        dataList: [],
        transverseData: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0,
      },

      waterDrop: {
        teacher: 0, // 图6 资源库无活动数据情况
        student: 0, // 图6 资源库无活动数据情况
        resource: 0, // 图6 资源库无活动数据情况
        lastresource: 0, // 图11 资源库无访问资源较上月变化情况
        majorteacher: 0, // 图8 主持院校与参建院校新增占比情况
        majorstudent: 0, // 图8 主持院校与参建院校新增占比情况
        unitteacher: 0, // 图8 主持院校与参建院校新增占比情况
        unitstudent: 0, // 图8 主持院校与参建院校新增占比情况
        teacherNum: 0,
        studentNum: 0,
        resourceNum: 0,
        lastresourceNum: 0,
        majorteacherNum: 0,
        majorstudentNum: 0,
        unitteacherNum: 0,
        unitstudentNum: 0,
      },

      majorUser: { // 图8 主持院校与参建院校新增占比情况
        teacher: 0,
        student: 0,
        cjteacher: 0,
        cjstudent: 0,
      },
      kechengActiveTop: {
        dataList: [],
        colorList: [],
        transverseData: []
      },
      tearchTopList: {
        dataList: [],
        colorList: [],
        transverseData: []
      },
      studentTopList: {
        dataList: [],
        colorList: [],
        transverseData: []
      },
      sss: {
        total: 0,
        dataList: [],
        colorList: [],
        transverseData: [],
        ziyuansucai: 0,
        luntan: 0,
        zuoye: 0,
        kaoshi: 0,
        sucaiAvg: 0
      },
      totalNum: 0,
      loading: '', // 是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
      const year = this.$route.query.yearOrMonth
      const monthly = this.$route.query.yearOrMonth
      // const endTime = this.$route.query.endTime
      // const year = this.$route.query.yearOrMonth.substring(0, 4);
      // const monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length);
      this.$route.query.startTime = `${year}-${monthly}-${1}`;
      this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
      this.header = this.$route.query;
      this.year = `${year}-${monthly}`;
      this.yearAndMonthly = this.$route.query.yearOrMonth;
      this.yearMonthText = `主持单位：日照职业技术学院，厦门海洋职业技术学院`;
    }
    this.getas()
    this.resourceLibraryDom()
    // 图1
    this.getZykStatus();        //   获取资源库状态
    // 当前资源库用户情况
    this.getUserCount()
    // 删除用户数
    this.del()
    //  图 1-2
    this.UserCreateLists()
    this.shengfenPer()
    this.getUserRegisterTime()
    // 图 1-3
    this.projectTopLists()

    // 图2-1
    // this.resourcesMonthDom();
    this.sucaiziyuanAlls()
    this.sucaiziyuanadd()
    this.sucaidel()
    this.sucaiziyuanCreateds()
    this.SucaiziyuanCreateds()
    // 图3-1
    this.kechenAlls()
    this.kechengcreated()

    // 图片 4-3
    this.UserTime()
    this.userTOtals()
    this.Userxingweis()
    this.useractiveTime()
    this.useractiveAll()
    // 图 5-1 
    this.sucaiziyuanyingyongs()

    this.sucaiziyuanfagnwens()

    // 6-1 近一年课程资源访问情况
    this.oneYearkechengs()
    // 6-2 课程访问量排名
    this.oneYearkechengfagnwens()
    // 6-3  课程活跃用户量排名
    this.kechengActiveTops()

    // 7-1 教师访问排名
    this.tearchTop()
    // 7-2 学生访问排名
    this.studentTop()

  },
  methods: {
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        courseName: '',
        isAll: false,
        month: this.yearAndMonthly,
        reportType: 0,
        zykId: sessionStorage.getItem('zykId'),
        zykName: this.header.zykName,
        zykNum: this.header.zykNum,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          window.open(res.data);
          this.loading.close();
        }
      }).catch(() => {
        this.loading.close();
      });
    },
    getas() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false
      }).then((res) => {
        this.header = res.data
      })
    },
    // 获取资源库状态
    getZykStatus() {
      this.$axios.post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem('zykId'), {
        loading: false,
      }).then((res) => {
        if (res) {
          this.zykStatus = res.data;
        }
      });
    },

    // 用户总览 - 历年用户新增资源 (头部报文)
    resourceLibraryDom() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 1, {
        loading: false,
      }).then((res) => {
        let total = 0
        let arrList = []
        for (let i = 0; i <= res.data.length - 1; i++) {
          total += parseFloat(res.data[i].num)
          arrList.push(res.data[i].num)
        }
        this.resourceLibrary.total = total
        // 年份
        this.resourceLibrary.FristYear = res.data[0].yearUpdate
        this.resourceLibrary.SecondYear = res.data[1].yearUpdate
        this.resourceLibrary.ThirdYear = res.data[2].yearUpdate
        this.resourceLibrary.FourthYear = res.data[3].yearUpdate

        // 数量
        this.resourceLibrary.FristNum = res.data[0].num
        this.resourceLibrary.SecondNum = res.data[1].num
        this.resourceLibrary.ThirdNum = res.data[2].num
        this.resourceLibrary.FourthNum = res.data[3].num

      });
    },

    // 用户总览 - 删除用户数 (头部报文)
    del() {
      this.$axios.post(this.$apiurls.report_yaer_getDeleteNum, 1, {
        loading: false
      }).then((res) => {
        this.resourceLibrary.delNum = res.data
      })
    },

    // 图1-1  用户总览头部报文
    getUserCount() {
      this.$axios.post(this.$apiurls.ReportFile_getBriefUserCount, {
        loading: false
      }).then((res) => {

        let arrList = []
        arrList.push({
          name: '学生',
          value: res.data.student
        }, {
          name: '教师',
          value: res.data.teacher
        })
        this.ziyuan = res.data
        this.ziyuan.teacherList = parseFloat(((this.ziyuan.teacher / this.ziyuan.total) * 100).toFixed(2))
        this.ziyuan.studentList = parseFloat(((this.ziyuan.student / this.ziyuan.total) * 100).toFixed(2))
        this.ziyuan.dataList = arrList
      })
    },
    // 图2-1  省份人数
    shengfenPer() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefProvinceDistribution, 1, {
        loading: false
      }).then((res) => {

        this.shengfenperson.dataList = res.data
        this.shengfenperson.colorList = this.colorList
      })
    },
    //  1-2   资源库用户注册时间分布
    getUserRegisterTime() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 1, {
        loading: false,
      }).then((res) => {
        let arrList = []
        let transverse = []
        for (let i = 0; i <= res.data.length - 1; i++) {
          arrList.push(res.data[i].num)
        }
        for (let i = 0; i <= res.data.length - 1; i++) {
          transverse.push(res.data[i].yearUpdate.substring(0, 5))
        }

        this.register.dataList = arrList
        this.register.transverseData = transverse
        this.register.colorList = this.colorList
        this.register.legendList = ['年用户注册数']
      });
    },
    // 图1-2  新用户注册情况分布
    UserCreateLists() {
      this.$axios.post(this.$apiurls.ReportFile_getBriefUserNew, 1, {
        loading: false
      }).then((res) => {
        this.UserCreateList.dataList = res.data.value
        this.UserCreateList.colorList = this.colorList;
        this.UserCreateList.transverseData = res.data.name
        this.UserCreateList.legendList = ['用户注册数量']
      })
    },

    // 图1-3  单位参建排名
    projectTopLists() {
      this.$axios.post(this.$apiurls.ReportFile_getBriefSchoolUserHot, 1, {
        loading: false,
      }).then((res) => {
        let arrList = []
        let transverse = []
        if (res) {
          for (let i = 0; i <= res.data.name.length - 1; i++) {
            arrList.push(res.data.value[i])
            transverse.push(res.data.name[i])
          }
        }
        this.projectTop.dataList = arrList
        this.projectTop.transverseData = transverse
        this.projectTop.colorList = this.colorList
      });
    },

    // 图2-1 (用户建设与更新情况) 素材资源总览占比部分报文
    sucaiziyuanAlls() {
      this.$axios.post(this.$apiurls.report_year_getBasicReportResourceVo, {
        loading: false,
      }).then((res) => {

        let arrList = []
        arrList.push({
          name: '文本类/图形图像',
          value: res.data.textVo.sumValue
        }, {
          name: '文本型演示文稿(ppt、网页课件与富媒体等)',
          value: res.data.textPPTVo.sumValue
        }, {
          name: '动画类',
          value: res.data.animationVo.sumValue
        }, {
          name: '虚拟仿真类',
          value: res.data.virtualVo.sumValue
        }, {
          name: '音频类',
          value: res.data.audioVo.sumValue
        }, {
          name: '视频类',
          value: res.data.videoVo.sumValue
        }, {
          name: '微课类',
          value: res.data.smallCourseVo.sumValue
        }, {
          name: '其他类',
          value: res.data.otherVo.sumValue
        })
        this.sucaiziyuanAll.dataList = arrList
        this.sucaiziyuanAll.textVo = res.data.textVo
        this.sucaiziyuanAll.textPPTVo = res.data.textPPTVo
        this.sucaiziyuanAll.animationVo = res.data.animationVo
        this.sucaiziyuanAll.virtualVo = res.data.virtualVo
        this.sucaiziyuanAll.audioVo = res.data.audioVo
        this.sucaiziyuanAll.videoVo = res.data.videoVo
        this.sucaiziyuanAll.smallCourseVo = res.data.smallCourseVo
        this.sucaiziyuanAll.otherVo = res.data.otherVo
        this.sucaiziyuanAll.originVo = res.data.originVo
        this.sucaiziyuanAll.noActiveResourceCountVo = res.data.noActiveResourceCountVo
        this.sucaiziyuanAll.courseResourceVo = res.data.courseResourceVo
        this.sucaiziyuanAll.questionVo = res.data.questionVo
        this.sucaiziyuanAll.viewResourceVo = res.data.viewResourceVo
        this.sucaiziyuanAll.commentResourceVo = res.data.commentResourceVo
        this.sucaiziyuanAll.downloadResourceVo = res.data.downloadResourceVo
        this.sucaiziyuanAll.collectionResourceVo = res.data.collectionResourceVo
        this.sucaiziyuanAll.otherResourceVo = res.data.otherResourceVo
        this.sucaiziyuanAll.total = res.data.resourceCount
        this.sucaiziyuanAll.textPPTVo.percentage = parseFloat(this.sucaiziyuanAll.textPPTVo.percentage) + parseFloat(this.sucaiziyuanAll.textVo.percentage) + '%'

      });
    },

    // 图 2-1 (用户建设与更新情况) 素材年份用户增长部分报文
    sucaiziyuanadd() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 3, {
        loading: false,
      }).then((res) => {

        this.sucaiyearAdd.FristYear = res.data[0].yearUpdate
        this.sucaiyearAdd.SecondYear = res.data[1].yearUpdate
        this.sucaiyearAdd.ThirdYear = res.data[2].yearUpdate
        this.sucaiyearAdd.FourthYear = res.data[3].yearUpdate
        // this.sucaiyearAdd.FifthYear = res.data[4].yearUpdate

        this.sucaiyearAdd.FristNum = res.data[0].num
        this.sucaiyearAdd.SecondNum = res.data[1].num
        this.sucaiyearAdd.ThirdNum = res.data[2].num
        this.sucaiyearAdd.FourthNum = res.data[3].num
        // this.sucaiyearAdd.FifthNum = res.data[4].num

      })
    },

    // 图 2-1 (用户建设与更新情况) 素材年份用户删除部分报文
    sucaidel() {
      this.$axios.post(this.$apiurls.report_yaer_getDeleteNum, 2, {
        loading: false,
      }).then((res) => {
        this.sucaiyearAdd.delNum = res.data
      })
    },
    // 素材资源创建时间分布柱型图
    sucaiziyuanCreateds() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 3, {
        loading: false,
      }).then((res) => {

        let arrList = []
        let transverse = []
        for (let i = 0; i <= res.data.length - 1; i++) {
          arrList.push(res.data[i].num)
          transverse.push(res.data[i].yearUpdate.substring(0, 5))
        }
        this.sucaiziyuanCreated.dataList = arrList
        this.sucaiziyuanCreated.transverseData = transverse
        this.sucaiziyuanCreated.colorList = this.colorList
        this.sucaiziyuanCreated.legendList = ['年资源新增']
      })
    },
    // 素材资源创建时间分布折线图
    SucaiziyuanCreateds() {
      this.$axios.post(this.$apiurls.ReportFile_getBriefUserNew, 2, {
        loading: false,
      }).then((res) => {
        this.SucaiziyuanCreated.dataList = res.data.value
        this.SucaiziyuanCreated.transverseData = res.data.name
        this.SucaiziyuanCreated.colorList = this.colorList
        this.SucaiziyuanCreated.legendList = ['年资源创建数']
      })
    },
    // 图 3-1 (课程建设与更新情况)  课程总览
    kechenAlls() {
      this.$axios.post(this.$apiurls.report_year_getCourseCountVo, {
        loading: false,
      }).then((res) => {
        this.kechengAll.count = res.data.courseBzNum
      })
    },

    // 图 3-2  课程创建时间分布
    kechengcreated() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefUserByYear, 3, {
        loading: false,
      }).then((res) => {
        let transverse = []
        for (let i = 0; i <= res.data.name.length - 1; i++) {
          transverse.push(res.data.name[i] + '年')
        }
        this.kechengcreateds.dataList = res.data.value;
        this.kechengcreateds.transverseData = transverse;
        this.kechengcreateds.colorList = this.colorList;
      })
    },


    // 用户行为总览
    useractiveAll() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 2, {
        loading: false,
      }).then((res) => {
        let arrList = []
        this.useractiveAllList.total = res.data[0].num
        this.useractiveAllList.sucai = res.data[2].num
        this.useractiveAllList.sucaiAvg = ((this.useractiveAllList.sucai / this.sucaiziyuanAll.total)).toFixed(2)
        this.useractiveAllList.luntan = res.data[3].num
        this.useractiveAllList.zuoye = res.data[4].num
        this.useractiveAllList.kaoshi = res.data[5].num

        arrList.push({
          name: res.data[1].action,
          value: res.data[1].num
        }, {
          name: res.data[2].action,
          value: res.data[2].num
        }, {
          name: res.data[3].action,
          value: res.data[3].num
        }, {
          name: res.data[4].action,
          value: res.data[4].num
        }, {
          name: res.data[5].action,
          value: res.data[5].num
        }, {
          name: res.data[6].action,
          value: res.data[6].num
        })

        this.useractiveAllList.dataList = arrList

      })
    },
    // 用户行为类型分布 (2021用户行为总量头部报文)
    userTOtals() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefUserActionTotal, {
        loading: false,
      }).then((res) => {
        this.userTotal = res.data
      })
    },

    // 图 4-1 用户行为类型分布   (近一年不同类型用户行为时间分布情况(按照天统计)  (单位:次)

    useractiveTime() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefUserByDayDistribution, {
        loading: false,
      }).then((res) => {
        // console.log()
        let total = 0
        for (let i = 0; i <= res.data.value.length - 1; i++) {
          total += parseFloat(res.data.value[i])
        }
        this.sss.total = total
        this.sss.dataList = res.data.value
        this.sss.transverseData = res.data.name
        this.sss.colorList = this.colorList
      })
    },

    // 图 4-2 不同类型用户行为分布
    Userxingweis() {
      this.$axios.post(this.$apiurls.applicationReport_getBriefUserByTypeDistribution, {
        loading: false
      }).then((res) => {
        let arrList = []
        arrList.push({
          name: res.data[0].name + '：' + res.data[0].value + '次',
          value: res.data[0].value
        }, {
          name: res.data[1].name + '：' + res.data[1].value + '次',
          value: res.data[1].value
        }, {
          name: res.data[2].name + '：' + res.data[2].value + '次',
          value: res.data[2].value
        }, {
          name: res.data[3].name + '：' + res.data[3].value + '次',
          value: res.data[3].value
        })
        this.userxingwei.dataList = arrList
      })
    },

    //  图 4-3 近一年不同类型用户行为时间分布情况
    UserTime() {
      this.$axios.post(this.$apiurls.ReportFile_getBriefUserByTypeDayDistribution, {
        loading: false,
      }).then((res) => {
        this.differentUserTime.dataList = res.data.dataList
        this.differentUserTime.transverseData = res.data.transverseData
        this.differentUserTime.legendList = res.data.legendList
        this.differentUserTime.colorList = this.colorList
      })
    },


    // 图5-1 近一年素材资源访问情况
    sucaiziyuanyingyongs() {
      this.$axios.post(this.$apiurls.overallPortrait_getResourceCountByType, 30, {
        loading: false,
      }).then((res) => {
        this.sucaiziyuanyingyong.dataList = res.data.dataList
        this.sucaiziyuanyingyong.transverseData = res.data.transverseData
        this.sucaiziyuanyingyong.legendList = res.data.legendList
        this.sucaiziyuanyingyong.colorList = this.colorList
        this.sucaiziyuanyingyong.legendList = ['访问量']
      })
    },
    // 图5-2 素材资源访问量排名
    sucaiziyuanfagnwens() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 26, {
        loading: false,
      }).then((res) => {

        this.sucaiziyuanfagnwen.dataList = res.data.value
        this.sucaiziyuanfagnwen.transverseData = res.data.name
        this.sucaiziyuanfagnwen.colorList = this.colorList
      })
    },

    // 图 6-1 近一年课程资源访问情况
    oneYearkechengs() {
      this.$axios.post(this.$apiurls.curriculumPortrait_getCourseMonthlyActionCountEchart, { limitNum: 10, statType: 43 }, {
        loading: false,
      }).then((res) => {

        let arr = []
        for (let i = 0; i <= res.data.length - 1; i++) {
          arr.push(res.data[i].value)
        }
        this.oneYearkecheng.dataList = arr
        this.oneYearkecheng.colorList = this.colorList
        this.oneYearkecheng.transverseData = res.data[0].name
        this.oneYearkecheng.legendList = ['标准化课程', '个性化课程']
      })
    },

    // 6-2  课程访问量排名
    oneYearkechengfagnwens() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 25, {
        loading: false,
      }).then((res) => {
        this.oneYearkechengfagnwen.dataList = res.data.value
        this.oneYearkechengfagnwen.transverseData = res.data.name
        this.oneYearkechengfagnwen.colorList = this.colorList
      })
    },

    // 6-3  课程活跃用户量排名
    kechengActiveTops() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 20, {
        loading: false,
      }).then((res) => {
        this.kechengActiveTop.dataList = res.data.value
        this.kechengActiveTop.transverseData = res.data.name
        this.kechengActiveTop.colorList = this.colorList1
      })
    },

    // 7-1  教师访问量排名
    tearchTop() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 6, {
        loading: false,
      }).then((res) => {
        this.tearchTopList.dataList = res.data.value
        this.tearchTopList.transverseData = res.data.name
        this.tearchTopList.colorList = this.colorList
      })
    },

    studentTop() {
      this.$axios.post(this.$apiurls.Lv2ReportFile_getBriefHotResource, 11, {
        loading: false,
      }).then((res) => {
        this.studentTopList.dataList = res.data.value
        this.studentTopList.transverseData = res.data.name
        this.studentTopList.colorList = this.colorList1
      })
    },

    // 进度条上的百分比值转化
    teacherFormat() {
      return `${this.waterDrop.teacherNum}%`;
    },
    studentFormat() {
      return `${this.waterDrop.studentNum}%`;
    },
    resourceFormat() {
      return `${this.waterDrop.resourceNum}%`;
    },
    lastresourceFormat() {
      return `${this.waterDrop.lastresourceNum}%`;
    },
    majorteacherFormat() {
      return `${this.waterDrop.majorteacherNum}%`;
    },
    majorstudentFormat() {
      return `${this.waterDrop.majorstudentNum}%`;
    },
    unitteacherFormat() {
      return `${this.waterDrop.unitteacherNum}%`;
    },
    unitstudentFormat() {
      return `${this.waterDrop.unitstudentNum}%`;
    },
  },
};
</script>

<style scoped>
.analysisReport {
  box-sizing: border-box;
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 70%;
  margin: 0px auto;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 26px;
  font-weight: bold;
  color: #1d244e;
  line-height: 30px;
  margin-top: 41px;
}

.header_titles .monthly {
  font-size: 18px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}
.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 17px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;

  position: relative;
  clear: both;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 20px;
  color: #1d244e;
  font-size: 23px;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  margin-left: 0px;
  clear: both;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 18px;
  color: #1d244e;
  line-height: 30px;
}
.chart_box p {
  font-size: 17px;
  text-indent: 2em;
  line-height: 28px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 17px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}
</style>

<style>
::-webkit-scrollbar {
  width: 10px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}
</style>
